// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3G3gp","cell":"ColumnAccessor_cell__6xlNk","firstCellAccent":"ColumnAccessor_firstCellAccent__2K99_"};